import React, { memo, useCallback, useMemo } from "react";
import { StyleSheet } from "react-native";
import EmptyPicture from "app/components/common/EmptyPicture";
import FastImage from "react-native-fast-image";
import { Box } from "app/components/common/Box/MainBox/MainBox";
import theme from "app/Theme/Theme";
import normalize from "app/utils/normalize";
import PictureName from "app/components/common/PictureName";

const PICTURE_SIZE = normalize(30);

const styles = StyleSheet.create({
  picture: {
    marginRight: -PICTURE_SIZE / 3 + normalize(1),
    height: PICTURE_SIZE,
    width: PICTURE_SIZE,
    borderRadius: 250,
    borderColor: theme.colors["neutral.white"],
    borderWidth: 2,
  },
});

interface Avatar {
  picture?: string;
  firstName?: string;
  name?: string;
  _id?: string;
}

interface Props {
  avatars: Avatar[];
  size?: number;
  maxNumberOfAvatars?: number;
}

const MultipleAvatars = ({ avatars, size, maxNumberOfAvatars = 0 }: Props) => {
  const getPictureStyle = useCallback(
    index => {
      return [
        styles.picture,
        {
          width: size || PICTURE_SIZE,
          height: size || PICTURE_SIZE,
          borderWidth: size ? 1 : 2,
          borderColor: theme.colors["neutral.50"],
          zIndex: index,
        },
      ];
    },
    [size],
  );

  const avatarsToDisplay = useMemo(() => {
    if (maxNumberOfAvatars) return avatars.slice(0, maxNumberOfAvatars);
    return avatars;
  }, [avatars, maxNumberOfAvatars]);

  return (
    <Box flexDirection="row" alignItems="center">
      {avatarsToDisplay?.map((user, index) => {
        return (
          <PictureName
            pictureSize={size || PICTURE_SIZE}
            imageUrl={user?.picture}
            name={user?.firstName || user?.name}
            style={getPictureStyle(index)}
            key={index}
          />
        );
      })}
    </Box>
  );
};

export default memo(MultipleAvatars);
